import { render, staticRenderFns } from "./table-quarternary.vue?vue&type=template&id=7f0f8c84&scoped=true"
import script from "./table-quarternary.vue?vue&type=script&lang=js"
export * from "./table-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f8c84",
  null
  
)

export default component.exports